import {useLocation, useParams, useSearchParams} from 'react-router-dom';
import {SurveyData} from 'screens/InsomniaSurvey/utils/surveyData';
import {getPartnerForCode, Partner} from './partners';

export function usePartnerBranding(): {partner: Partner | null} {
  const params = useParams<{referralCode?: string}>();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const stateCode = (location.state as {referralCode?: string} | null)?.referralCode;
  const stored = SurveyData.read()?.referral_code as string | undefined;

  const code = params.referralCode ?? stateCode ?? searchParams.get('ref') ?? searchParams.get('referral') ?? stored;

  return {partner: getPartnerForCode(code)};
}
